import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { CancellationReasonField } from './CancellationReasonField.js';

const CancellationReasonFieldContainer = ({ selectedCancellationType , required  })=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            cancellationType: {
                label: getLabel('cancelSubscription.field.cancellationType'),
                placeholder: getLabel('cancelSubscription.field.cancellationType.placeholder'),
                errorMessage: getLabel('cancelSubscription.field.cancellationType.errorMessage'),
                options: {
                    ordinary: getLabel('cancelSubscription.field.cancellationType.ordinary'),
                    extraordinary: getLabel('cancelSubscription.field.cancellationType.extraordinary')
                }
            },
            reason: {
                label: getLabel('cancelSubscription.field.reason'),
                placeholder: getLabel('cancelSubscription.field.reason.placeholder'),
                errorMessage: getLabel('cancelSubscription.field.reason.errorMessage'),
                options: {
                    changedPrescription: getLabel('cancelSubscription.field.reason.changedPrescription'),
                    notNeeded: getLabel('cancelSubscription.field.reason.notNeeded'),
                    tooExpensive: getLabel('cancelSubscription.field.reason.tooExpensive'),
                    foundAnotherProduct: getLabel('cancelSubscription.field.reason.foundAnotherProduct'),
                    deliveryProblems: getLabel('cancelSubscription.field.reason.deliveryProblems'),
                    subscriptionManagementProblems: getLabel('cancelSubscription.field.reason.subscriptionManagementProblems'),
                    other: getLabel('cancelSubscription.field.reason.other')
                }
            }
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(CancellationReasonField, {
        selectedCancellationType: selectedCancellationType,
        labels: labels,
        required: required
    });
};

export { CancellationReasonFieldContainer };
//# sourceMappingURL=CancellationReasonFieldContainer.js.map
